/* eslint-disable react/display-name */
export const EN_US = {
    values: {
        'Real Time': 'Real Time',
        'Data reprocessing': 'Data reprocessing',
        Reprocessing_: 'Reprocessing',
        SEC: 'SEC',
        'Data reprocessing completed successfully': 'Data reprocessing completed successfully',
        'Waiting for performance reprocessing': 'Waiting for performance reprocessing',
        Waiting: 'Waiting',
        'No data found': 'No data found',
        Initializing: 'Initializing',
        'Reprocessing Rig Floor KPI data.': 'Reprocessing Rig Floor KPI data.',
        'No Rig Floor KPI data being reprocessed.': 'No Rig Floor KPI data being reprocessed.',
        'Rig Floor reprocessing has finished successfully!': 'Rig Floor reprocessing has finished successfully!',
        'Only Performance KPIs': 'Only Performance KPIs',
        'Channels Configuration for Rig Floor': 'Channels Configuration for Rig Floor',
        'CHANNELS INTERPOLATION': 'CHANNELS INTERPOLATION',
        'INTERPOLATION FREQUENCY': 'INTERPOLATION FREQUENCY',
        'MAX DELTA WITHOUT INTERPOLATION': 'MAX DELTA WITHOUT INTERPOLATION',
        'No equipment selected': 'No equipment selected',
        'Rig Floor Equipments': 'Rig Floor Equipments',
        'Riser Equipments': 'Riser Equipments',
        'Rig Floor channels config': 'Rig Floor channels config',
        'Riser channels config': 'Riser channels config',
        'Rig Floor channels configurations': 'Rig Floor channels configurations',
        'Riser channels configurations': 'Riser channels configurations',
        'Channels interpolation': 'Channels interpolation',
        'Rig Floor Status': 'Rig Floor Status',
        'Generating Rig Floor KPI data.': 'Generating Rig Floor KPI data.',
        'No Rig Floor KPI data being generated.': 'No Rig Floor KPI data being generated.',
        'Real-time event production has been terminated': 'Real-time event production has been terminated',
        'Performance KPIs production started successfully!': 'Performance KPIs production started successfully!',
        'Performance and RIG Floor KPIs production started successfully!':
            'Performance and RIG Floor KPIs production started successfully!',
        'Here you will see the equipment associated with this RIG and a Hydratong archetype.':
            'Here you will see the equipment associated with this RIG and a Hydratong archetype.',
        'Here you will see the equipment associated with this RIG and a Hydraracker archetype.':
            'Here you will see the equipment associated with this RIG and a Hydraracker archetype.',
        'Here you will see the equipment associated with this RIG and a Top Drive archetype.':
            'Here you will see the equipment associated with this RIG and a Top Drive archetype.',
        Riser: 'Riser',
        'Here you will see the equipment associated with this RIG and a RRT archetype.':
            'Here you will see the equipment associated with this RIG and a RRT archetype.',
        'Here you will see the equipment associated with this RIG and a Catwalk archetype.':
            'Here you will see the equipment associated with this RIG and a Catwalk archetype.',
        "It's not possible to configure channels while Reprocessing is Running. You need to stop Reprocessing to access Channels Configurations.":
            "It's not possible to configure channels while Reprocessing is Running. You need to stop Reprocessing to access Channels Configurations.",
        'Applied successfully!': 'Applied successfully!',
        'Error saving!': 'Error saving!',
        'The event time range does not align with a stand or overlaps with multiple stands.':
            'The event time range does not align with a stand or overlaps with multiple stands.',
        'No stand was found for the event time range.': 'No stand was found for the event time range.',
        'A KPI with this indicator already exists for the associated stand.':
            'A KPI with this indicator already exists for the associated stand.',
        'Events created successfully.': 'Events created successfully.',
        Loading: 'Loading',
        Success: 'Success',
        Error: 'Error',
        'An unexpected error has occurred.': 'An unexpected error has occurred.',
        'Creating events...': 'Creating events...',
        'Updating events...': 'Updating events...',
        'Deleting events...': 'Deleting events...',
        'Events deleted successfully': 'Events deleted successfully',
        'was created successfully': 'was created successfully',
        'was updated successfully': 'was updated successfully',
        failed: 'failed',
        reason: 'reason',
        'Events updated successfully.': 'Events updated successfully.',
        'Failed to delete events': 'Failed to delete events',
        Clear: 'Clear',
        Apply: 'Apply',
        Verify: 'Verify',
        Verified: 'Verified',
        Start: 'Start',
        End: 'End',
        Duration: 'Duration',
        'Overlaps with': 'Overlaps with',
        'New row': 'New row',
        'End time out of selected range': 'End time out of selected range',
        'End time must be after start time': 'End time must be after start time',
        'Invalid date/time': 'Invalid date/time',
        'Start time out of allowed range': 'Start time out of allowed range',
        'Add row': 'Add row',
        'Please select an asset': 'Please select an asset',
        'Correct errors before saving': 'Correct errors before saving',
        'SELECT KPIS': 'Select KPIs',
        'KPI selected': 'KPI selected',
        'KPIs selected': 'KPIs selected',
        'KPIs that are not present on the selected timestamp will be disabled on this filter.':
            'KPIs that are not present on the selected timestamp will be disabled on this filter.',
        'No KPIs in the selected time frame': 'No KPIs in the selected time frame',
        APPLY: 'Apply',
        'Restore default': 'Restore default',
        'The amount of KPIs loaded is limited to 100 for better visualization and performance':
            'The amount of KPIs loaded is limited to 100 for better visualization and performance',
        'The indicator is missing from the KPI event.': 'The indicator is missing from the KPI event.',
        'The KPI indicator is unknown.': 'The KPI indicator is unknown.',
        'The current event indicator is not aligned with the associated stand indicator.':
            'The current event indicator is not aligned with the associated stand indicator.',
        'Invalid start or end timestamp.': 'Invalid start or end timestamp.',
        'All events verified successfully': 'All events verified successfully',
        'Some events have validation errors': 'Some events have validation errors',
        'Verification failed': 'Verification failed',
        'An unexpected error occurred during verification': 'An unexpected error occurred during verification',
        Displaying: 'Displaying',
        'KPIs (covering': 'KPIs (covering',
        'hours out of': 'hours out of',
        'hours selected). Reduce the time interval to access all KPIs for the period.':
            'hours selected). Reduce the time interval to access all KPIs for the period.'
    }
}
